import {GetVexWorkbenchItemsQuery} from 'features/Dashboard/hooks/workbenchItems.generated';
import {KeywordStatus, RegulatoryDocumentStatus} from 'types';

const KeywordMockupRed: {__typename?: 'Keyword'; id: string; name: string} = {
	id: 'RedKeywordMockup',
	name: 'Red Keyword',
	__typename: 'Keyword' as const,
};

const KeywordMockupBlue: {__typename?: 'Keyword'; id: string; name: string} = {
	id: 'BlueKeywordMockup',
	name: 'Blue Keyword',
	__typename: 'Keyword' as const,
};

const KeywordMockupBoth: {__typename?: 'Keyword'; id: string; name: string}[] =
	[KeywordMockupBlue, KeywordMockupRed];

const KeywordsMockupRed: {__typename?: 'Keyword'; id: string; name: string}[] =
	[KeywordMockupRed];

const VexClusterMockupRed = {
	id: 'RedVexCluster',
	name: 'Red Vex Cluster',
	__typename: 'VexCluster' as const,
};

const VexClusterMockupBlue = {
	id: 'BlueVexCluster',
	name: 'Blue Vex Cluster',
	__typename: 'VexCluster' as const,
};

const VexClusterMockupPablo = {
	id: 'VmV4Q2x1c3RlcgpkNjcwZTQwNjNiZDFkY2VjZWMzZTdjMzIz',
	name: 'Pablo VEX-CLUSTER',
	__typename: 'VexCluster' as const,
};

const VexClusterMockupPicasso = {
	id: 'VmV4Q2x1c3RlcgpkNjkxZGFmYzIxMDIzNGFlZTBjZjllMDNh',
	name: 'Picasso VEX-CLUSTER',
	__typename: 'VexCluster' as const,
};

const KeywordAssignmentMockupRed = {
	__typename: 'KeywordAssignment' as const,
	keyword: KeywordMockupRed,
	vexClusterAssignments: [
		{
			vexCluster: VexClusterMockupRed,
			keywordStatus: KeywordStatus.New,
			__typename: 'VexClusterAssignment' as const,
		},
	],
};
const KeywordAssignmentMockupBlue = {
	__typename: 'KeywordAssignment' as const,
	keyword: KeywordMockupBlue,
	vexClusterAssignments: [
		{
			vexCluster: VexClusterMockupBlue,
			keywordStatus: KeywordStatus.New,
			__typename: 'VexClusterAssignment' as const,
		},
	],
};
const KeywordAssignmentMockupPablo = {
	__typename: 'KeywordAssignment' as const,
	keyword: KeywordMockupRed,
	vexClusterAssignments: [
		{
			vexCluster: VexClusterMockupPablo,
			keywordStatus: KeywordStatus.New,
			__typename: 'VexClusterAssignment' as const,
		},
	],
};
const KeywordAssignmentMockupPicasso = {
	__typename: 'KeywordAssignment' as const,
	keyword: KeywordMockupBlue,
	vexClusterAssignments: [
		{
			vexCluster: VexClusterMockupPicasso,
			keywordStatus: KeywordStatus.New,
			__typename: 'VexClusterAssignment' as const,
		},
	],
};
const KeywordAssignmentMockupBoth = {
	__typename: 'KeywordAssignment' as const,
	keyword: KeywordMockupRed,
	vexClusterAssignments: [
		{
			vexCluster: VexClusterMockupRed,
			keywordStatus: KeywordStatus.New,
			__typename: 'VexClusterAssignment' as const,
		},
		{
			vexCluster: VexClusterMockupBlue,
			keywordStatus: KeywordStatus.New,
			__typename: 'VexClusterAssignment' as const,
		},
	],
};

const RegulationMockupCommon = {
	markets: [
		{id: 'TestMarket01', name: 'TestMarket01'},
		{id: 'TestMarket02', name: 'TestMarket02'},
		{id: 'TestMarket03', name: 'TestMarket03'},
		{id: 'TestMarket04', name: 'TestMarket04'},
		{id: 'TestMarket05', name: 'TestMarket05'},
		{id: 'TestMarket06', name: 'TestMarket06'},
		{id: 'TestMarket07', name: 'TestMarket07'},
		{id: 'TestMarket08', name: 'TestMarket08'},
		{id: 'TestMarket09', name: 'TestMarket09'},
		{id: 'TestMarket10', name: 'TestMarket10'},
		{id: 'TestMarket11', name: 'TestMarket11'},
		{id: 'TestMarket12', name: 'TestMarket12'},
		{id: 'TestMarket13', name: 'TestMarket13'},
		{id: 'TestMarket14', name: 'TestMarket14'},
		{id: 'TestMarket15', name: 'TestMarket15'},
		{id: 'TestMarket16', name: 'TestMarket16'},
		{id: 'TestMarket17', name: 'TestMarket17'},
		{id: 'TestMarket18', name: 'TestMarket18'},
	],
};

const VexWorkbenchItemCommon = {
	dueDate: '2025-05-23T09:47:41.799Z',
	marketNames: ['TestMarket01', 'TestMarket02'],
	regulatoryDocumentStatus: RegulatoryDocumentStatus.Final,
	vexClusterData: [
		{
			vexClusterName: 'Red Vex Cluster',
			paragraphCount: 2,
			__typename: 'VexWorkbenchItemClusterData' as const,
		},
	],
	__typename: 'VexWorkbenchItemSimplified' as const,
};

const generateVexWorkbenchItem = (index: number) => {
	const paddedIndex = String(index).padStart(3, '0');
	const overrides: Partial<
		typeof VexWorkbenchItemCommon & {
			regulationId: string;
			regulationName: string;
			regulatoryDocumentId: string;
			regulatoryDocumentName: string;
			regulationNumber: string;
			marketNames?: string[];
			dueDate?: string;
		}
	> = {};

	// Add variations for some items
	if (index === 2 || index === 3) {
		overrides.marketNames = [
			'TestMarket01',
			'TestMarket02',
			'TestMarket03',
			'TestMarket04',
		];
	} else if (index === 4 || index === 5) {
		overrides.marketNames = ['TestMarket01', 'TestMarket02', 'TestMarket03'];
	} else if (index === 6 || index === 7) {
		overrides.dueDate = '2030-05-23T09:47:41.799Z';
	}

	return {
		regulationId: `RegulationVexMockup${paddedIndex}`,
		regulationName: `Regulation Vex Mockup ${paddedIndex}`,
		regulatoryDocumentId: `RegDocVexMockup${paddedIndex}`,
		regulatoryDocumentName: `Regulatory Document Vex Mockup ${paddedIndex}`,
		regulationNumber: `RVEX-${paddedIndex}`,
		...VexWorkbenchItemCommon,
		...overrides,
	};
};

export const VexWorkbenchItemsSimplifiedMockup: GetVexWorkbenchItemsQuery = {
	vexWorkbenchItems: Array.from({length: 20}, (_, i) =>
		generateVexWorkbenchItem(i + 1),
	),
};
